export default __webpack_public_path__ + "static/media/mannotephone.365f7ee6.png";